import React, { useState } from 'react';
import { toast } from 'react-toastify';

const AddFloorModal = ({ isOpen, onClose, onSaveFloor }) => {
  const [floorName, setFloorName] = useState('');
  const [floorCode, setFloorCode] = useState('');
  const [description, setDescription] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!floorName.trim()) {
      toast.error("Please enter a floor name");
      return;
    }

    onSaveFloor({
      id: Date.now(),
      name: floorName.trim(),
      code: floorCode.trim() || `FL-${Math.floor(100 + Math.random() * 900)}`,
      description: description.trim() || 'Active Hospital Wing/Floor'
    });

    toast.success(`Hospital Floor "${floorName}" added successfully!`);
    setFloorName('');
    setFloorCode('');
    setDescription('');
    onClose();
  };

  return (
    <div className="manage-modal-backdrop" onClick={onClose}>
      <div className="manage-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="manage-modal-header">
          <h3>🏢 Add New Hospital Floor</h3>
          <button className="manage-modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="manage-modal-body">
            <div className="modal-form-group">
              <label>* Floor Name / Number</label>
              <input
                type="text"
                placeholder="e.g. 1st Floor, 2nd Floor, ICU Wing"
                value={floorName}
                onChange={(e) => setFloorName(e.target.value)}
                autoFocus
              />
            </div>

            <div className="modal-form-group">
              <label>Floor Code (Optional)</label>
              <input
                type="text"
                placeholder="e.g. FL-101, WING-A"
                value={floorCode}
                onChange={(e) => setFloorCode(e.target.value)}
              />
            </div>

            <div className="modal-form-group">
              <label>Description / Wing Details</label>
              <input
                type="text"
                placeholder="e.g. General Ward & Special Care"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>

          <div className="manage-modal-footer">
            <button type="button" className="modal-btn-cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-btn-save">Save Floor</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFloorModal;
